export const BRAND_QUERY_PARAM = 'brand';
export const GROUP_QUERY_PARAM = 'group';
export const LANGUAGE_QUERY_PARAM = 'language';
export const KNOWN_QUERY_PARAMS = [
  BRAND_QUERY_PARAM,
  GROUP_QUERY_PARAM,
  LANGUAGE_QUERY_PARAM
];
